import React, { useEffect } from "react";

export default function JotForm({ widget }) {
  const { formId, hostUrl, scriptUrl } = widget || {};

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (!formId || !hostUrl || !scriptUrl) return;

    const scriptExists = document.querySelector(`script[src="${scriptUrl}"]`);
    const loadHandler = () => {
      if (window.jotformEmbedHandler) {
        window.jotformEmbedHandler(
          `iframe[id='JotFormIFrame-${formId}']`,
          hostUrl
        );
      }
    };

    if (!scriptExists) {
      const script = document.createElement("script");
      script.src = scriptUrl;
      script.onload = loadHandler;
      document.body.appendChild(script);
    } else {
      loadHandler();
    }
  }, [formId, hostUrl, scriptUrl]);

  if (formId && hostUrl) {
    return (
      <iframe
        id={`JotFormIFrame-${formId}`}
        title="Patient Referral Form"
        src={`${hostUrl}${formId}`}
        width="100%"
        height="800"
        frameBorder="0"
        allowTransparency="true"
        allow="geolocation; microphone; camera; fullscreen"
        scrolling="no"
        style={{ border: "none", minHeight: "800px", marginBottom: 0 }}
      />
    );
  }

  return null;
}
